import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  SELECT_ALL,
  SELECTED_ITEMS,
} from 'constants/formFields';
import { tableCheckboxSchema } from 'utils/validators';

import type { TTableCheckboxSchema } from 'utils/validators';

const useQuestionForm = () => {
  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    watch,
  } = useForm<TTableCheckboxSchema>({
    mode: 'onChange',
    resolver: yupResolver(tableCheckboxSchema),
    defaultValues: {
      [SELECT_ALL]: '',
      [SELECTED_ITEMS]: [],
    },
  });

  return {
    control,
    handleSubmit,
    getValues,
    setValue,
    watch,
  };
};

export default useQuestionForm;
